import { CommonModule } from '@angular/common';
import { Component, DestroyRef, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterModule } from '@angular/router';
import { Actions, Store, ofActionSuccessful } from '@ngxs/store';
import { distinctUntilKeyChanged, filter, map, withLatestFrom } from 'rxjs';

import { LogoutFlowInitiated, UserRoles, UserState } from '@troyai/auth/data-access';
import { RolesDirective } from '@troyai/auth/feature';
import { ViewPersistencyService } from '@troyai/data-source-listing';
import { FeatureFlagDirective } from '@troyai/feature-flags';
import { SetGlobalPharmacy } from '@troyai/pharmacy-context/data-access';
import {
  PharmacyContextService,
  PharmacySelectorComponent,
} from '@troyai/pharmacy-context/feature';
import { isDemoMode } from '@troyai/portal/investor-demo/core';
import { NavMenuItemComponent } from '@troyai/ui-kit';
import { HelpMenuItemComponent } from '../help-menu-item/help-menu-item.component';

@Component({
  selector: 't-main-menu',
  imports: [
    CommonModule,
    RouterModule,
    NavMenuItemComponent,
    PharmacySelectorComponent,
    RolesDirective,
    HelpMenuItemComponent,
    FeatureFlagDirective,
  ],
  templateUrl: './main-menu.component.html',
})
export class MainMenuComponent implements OnInit {
  private store = inject(Store);
  private actions$ = inject(Actions);
  private pharmacyContextService = inject(PharmacyContextService);
  private viewPersistencyService = inject(ViewPersistencyService);

  user$ = this.store.select(UserState.user);
  userRoles$ = this.store.select(UserState.userRoles);
  isMOCCompliant$ = this.store.select(UserState.isMOCCompliant);
  currentTenantId$ = this.store.select(UserState.currentTenantId);

  /** Investor demo: adds the Care Console and Ledger items. */
  protected readonly demo = isDemoMode();

  @Output() menuItemSelected = new EventEmitter<void>();
  userRoles = UserRoles;
  destroyRef = inject(DestroyRef);
  cmPatientsPersistentViewParams: Record<string, unknown> = {};

  selectMenuItem() {
    this.menuItemSelected.emit();
  }

  logout(): void {
    this.store.dispatch(new LogoutFlowInitiated());
  }

  ngOnInit() {
    this.actions$
      .pipe(
        ofActionSuccessful(SetGlobalPharmacy),
        withLatestFrom(this.userRoles$),
        filter(([, userRoles]) => !!userRoles && userRoles.includes(UserRoles.PharmacyUser)),
        map(([newSelectedPharmacyAction]) => newSelectedPharmacyAction.payload.pharmacy),
        filter((newSelectedPharmacy) => !!newSelectedPharmacy.global_id),
        distinctUntilKeyChanged('global_id'),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((newSelectedPharmacy) => {
        this.pharmacyContextService.handlePharmacyChangeRedirects(newSelectedPharmacy);
      });

    // this.viewPersistencyService.views$.subscribe((views) => {
    //   if (views['cm-patients-listing']) {
    //     this.cmPatientsPersistentViewParams = views['cm-patients-listing'];
    //   }
    // });
  }
}
